<template>
  <div :class="outerClass">
    <form id="address-lookup" name="address lookup" :class="formClass" @submit.prevent="addressUpdate()">
      <div :class="innerClass">
        <input
          v-model="addressSearch"
          :class="inputClass"
          class="hidden md:block"
          type="text"
          :placeholder="placeholder"
          aria-label="Address"
          v-on:keyup="smartystreets"
          id="smartystreetsaddress"
          autocomplete="off"
          @focus="addressInputFocus()"
        />
        <input
          v-model="addressSearch"
          :class="inputClass"
          class="block md:hidden"
          type="text"
          :placeholder="mobilePlaceholder"
          aria-label="Address"
          v-on:keyup="smartystreets"
          id="smartystreetsaddress"
          autocomplete="off"
          @focus="addressInputFocus()"
        />

        <ul id="us-autocomplete-pro-menu" style="display:none;">
          <li
            v-for="(result, index) in smartyStreetsResults"
            :key="index"
            v-on:click="selectAddress(result)"
          >
            {{ result.street_line }}, {{ result.city }}, {{ result.state }},
            {{ result.zipcode }}
          </li>
        </ul>

        <input
          type="submit"
          :class="buttonClass"
          :value="text"
        />
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useNuxtApp } from '#app';

const props = defineProps({
  redirectPath: String,
  buttonText: String,
  isHomePageSearch: Boolean,
  placeholderText: String,
  mobilePlaceholderText: String,
});

const emits = defineEmits([
  "addressLookupComplete",
]);

const $app = useNuxtApp()
const { $sg, $st } = $app;

const smartyStreetsResults = ref(null);
const addressSearch = ref('');
const text = computed(() => props.buttonText ? props.buttonText : "Submit");

const addressInputFocus = () => {
  if (addressSearch.value === "Please enter a valid address") {
    addressSearch.value = "";
  }
};

const addressUpdate = async () => {
  if (addressSearch.value.split(',').length === 4) {
    await $sg.addressLookup(addressSearch.value, $app, true, props.redirectPath, null, null, true);
    emits("addressLookupComplete");
  } else {
    addressSearch.value = "Please enter a valid address";
  }
};

const smartystreets = async () => {
  if (addressSearch.value.length > 0) {
    const results = await $st.lookup(addressSearch.value);
    if (Object.keys(results).length > 0) {
      smartyStreetsResults.value = results.suggestions;
      document.getElementById("us-autocomplete-pro-menu").style.display = "block";
    }
  } else {
    document.getElementById("us-autocomplete-pro-menu").style.display = "none";
  }
};

const selectAddress = (element) => {
  addressSearch.value = `${element.street_line}, ${element.city}, ${element.state}, ${element.zipcode}`;
  document.getElementById("us-autocomplete-pro-menu").style.display = "none";
};

const outerClass = computed(() => props.isHomePageSearch ? 'hero-form' : '');
const formClass = computed(() => props.isHomePageSearch ? 'relative' : 'address-form relative bg-white w-11/12 justify-center mx-auto mt-6');
const innerClass = computed(() => props.isHomePageSearch ? '' : 'flex items-center justify-between relative round-form');
const inputClass = computed(() => props.isHomePageSearch ? 'hero-input' : 'appearance-none bg-transparent w-8/12 mt-0 mb-0 mr-3 py-2 px-2 leading-tight focus:outline-none rounded-3xl');
const buttonClass = computed(() => props.isHomePageSearch ? 'hero-submit' : 'address-button flex-shrink-0 text-sm font-bold button text-white py-3 px-1 rounded-3xl w-3/12');
const placeholder = computed(() => props.placeholderText ? props.placeholderText : (props.isHomePageSearch ? "Enter your address for personalized pricing" : "What address will be serviced?"));
const mobilePlaceholder = computed(() => props.mobilePlaceholderText ? props.mobilePlaceholderText : (props.isHomePageSearch ? "Enter address" : "What address will be serviced?"));
</script>

<style scoped>
.flex input[type="text"] {
  border: 4px solid #fff;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 100px;
}

.address-button {
  width: 25%;
  min-width: 100px;
}

::placeholder {
  color: #517185;
}

.hero-form {
  position: absolute;
  left: 3rem;
  top: 69%;
  background: #fff;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  padding: 10px 20px;
  width: 550px;
  max-width: calc(100% - 4rem);
  z-index: 60;
  box-shadow: 0 1px 4px #666;
}

.hero-input {
  border: none;
  margin: 0;
  background: url(~/assets/images/headerSearch.png) no-repeat 5px center;
  background-size: 24px;
  padding-left: 40px;
  width: 380px;
  text-overflow: ellipsis;
  max-width: calc(100% - 115px); /*115 = width of Get a Quote button*/
}

.hero-input:focus-visible {
  outline: 1px dotted #ccc;
}

.hero-submit , .hero-submit:hover {
  background: #ce4200;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

@media (max-width: 640px) {
  .hero-input {
    width: 100%;
  }
}
</style>
